import { faTicketAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Linkify from 'linkify-react';
import propTypes from 'prop-types';
import { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';
import Spinner from '../_generic/spinner/Spinner';

const VoucherInstructions = ({ instructions, title }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      {!instructions && <Spinner display="relative" testId="redeem-spinner" />}
      {instructions?.map((instruction, index) => (
        <div className="instructions-content" key={index}>
          <div className="icon">
            <FontAwesomeIcon icon={faTicketAlt} transform={{ rotate: -45 }} />
          </div>
          <div>
            <h2 className="title">
              {title}
              {instruction.title && `: ${instruction.title}`}
            </h2>
            <p className="instructions">
              <Linkify>{instruction.info}</Linkify>
            </p>
          </div>
        </div>
      ))}
      <style jsx>{`
        .instructions-content {
          border-bottom: 1px solid ${theme.colors.lightboxgrayborders};
          margin-bottom: 10px;
        }
        .instructions-content:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }
        .instructions {
          white-space: pre-wrap;
          word-wrap: break-word;
        }
        .icon {
          display: none;
          color: #ccc;
          font-size: 4em;
          margin: 0 30px 0 5px;
        }
        .title {
          color: ${theme.colors.primary};
          font-weight: normal;
          font-size: 1.2em;
          margin-bottom: 0;
          text-transform: capitalize;
        }
        .instructions :global(a) {
          color: ${theme.colors.primary};
        }

        @media (min-width: ${theme.breakpoints.lgUp}) {
          .icon {
            display: block;
          }
          .instructions-content {
            display: flex;
            align-items: flex-start;
          }
        }
      `}</style>
    </>
  );
};

VoucherInstructions.propTypes = {
  instructions: propTypes.array,
  title: propTypes.string,
};

export default VoucherInstructions;
